import { updatePrescription } from "../services/update-prescription";
import { usePrescriptionMutation } from "./use-prescription-mutation";

export function useUpdatePrescription() {
  return usePrescriptionMutation({
    mutationFn: updatePrescription,
    successMessage: "Prescription order updated successfully",
    errorMessage: "Failed to update prescription order",
  });
}
